export const sum_of_array_elem =(arr,key)=>{
    return arr?.reduce((sum, y) => sum + y[key], 0);
}